import axios from 'axios'
import { createError } from './flasher'

const baseAPI = process.env.REACT_APP_BASE_API

// Generic GET against /dashboard-v2/<path>. Each widget has its own slice;
// filter scoping follows the requirement: summary/expiring/schedule-delays
// are always-current (no params), the SLA pair shares a local period filter,
// and trend/top carry their own independent params.

const fetchV2 = (path, typePrefix) => (accessToken, params) => {
  return (dispatch) => {
    dispatch({
      type: `${typePrefix}_PENDING`
    })
    return axios({
      method: 'get',
      headers: { 'Authorization': `Bearer ${accessToken}` },
      url: `${baseAPI}/dashboard-v2/${path}`,
      params: params || {}
    }).then((x) => {
      dispatch({
        type: `${typePrefix}_FULFILLED`,
        payload: x.data
      })
    }).catch((e) => {
      console.error(e)
      dispatch(createError(e.message))
      dispatch({
        type: `${typePrefix}_REJECTED`,
        payload: e
      })
    })
  }
}

export const fetchDashboardSummary = fetchV2('summary', 'DASHBOARD_V2_SUMMARY')
export const fetchDashboardSlaAudit = fetchV2('sla-audit', 'DASHBOARD_V2_SLA_AUDIT')
export const fetchDashboardSlaVeto = fetchV2('sla-veto', 'DASHBOARD_V2_SLA_VETO')
export const fetchExpiringCertificates = fetchV2('expiring-certificates', 'DASHBOARD_V2_EXPIRING')
export const fetchAuditScheduleDelays = fetchV2('audit-schedule-delays', 'DASHBOARD_V2_SCHEDULE_DELAYS')
export const fetchOrderTrend = fetchV2('order-trend', 'DASHBOARD_V2_ORDER_TREND')
export const fetchTopCustomers = fetchV2('top-active', 'DASHBOARD_V2_TOP_CUSTOMERS')
export const fetchTopStandards = fetchV2('top-active', 'DASHBOARD_V2_TOP_STANDARDS')
